var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1905_20544)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 46,
    width: 34,
    height: 34,
    rx: 17,
    transform: "rotate(-180 52 46)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 45.5,
    width: 33,
    height: 33,
    rx: 16.5,
    transform: "rotate(-180 51.5 45.5)",
    stroke: "#C4C4C4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.07 19H29.4421C28.3933 19 27.5447 19.9 27.5447 21L27.5352 37C27.5352 38.1 28.3838 39 29.4326 39H40.884C41.9328 39 42.791 38.1 42.791 37V25L37.07 19ZM40.884 37H29.4421V21H36.1166V26H40.884V37ZM31.3491 32.01L32.6935 33.42L34.2096 31.84V36H36.1166V31.84L37.6326 33.43L38.977 32.01L35.1726 28L31.3491 32.01Z",
    fill: "#1B1C1C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1905_20544",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1905_20544"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1905_20544",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/uploadIcon.dce5588cdf874cf33be303fd76fa6893.svg";
export { ForwardRef as ReactComponent };